export default __webpack_public_path__ + "682adcea9e9289e9d07281b83e21b846.svg";